export const LINK_ROUTER_PATH = '/linkRouter';
export const LINK_ROUTER_PARAM = 'params';

const DEFAULT_DEEP_LINK = 'dashboard';

const ROUTE_MAP: Readonly<Record<string, string>> = {
  support: '/support',
  timeline: '/coaching-history',
  history: '/history',
  dashboard: '/dashboard',
};

export function getDeepLink(value: string | null): string {
  return Object.prototype.hasOwnProperty.call(ROUTE_MAP, value) ? value : DEFAULT_DEEP_LINK;
}

export function getDestination(deepLink: string): string {
  return ROUTE_MAP[getDeepLink(deepLink)];
}

export function getLinkRouterUrl(deepLink: string): string {
  return `${LINK_ROUTER_PATH}?${LINK_ROUTER_PARAM}=${encodeURIComponent(deepLink)}`;
}